// A token an admin has paused. The backend (TOKEN_TRADING_HALTED_ERROR) refuses every buy, sell,
// own-price order, fund investment and IPO commitment for it, so the pages show a notice in
// place of those actions. Absent or false = not halted. The internal halt reason is never shown.
export const TRADING_HALTED_NOTE = "Trading in this asset is paused.";
export const isTradingHalted = (token) => token?.trading_halted === true;
